import { Tag, Tooltip } from "antd";
import PropTypes from "prop-types";
import { HiDotsHorizontal } from "react-icons/hi";
import {
    formatCurrency,
    getPolicy,
    getProviderKey,
    isSalePaid,
    PROVIDER_LABELS,
} from "../../lib/insuranceSaleApi";
import { RowActionsMenu } from "../../../../components/data-table";

const InsuranceSaleMobileCard = ({
    record,
    t,
    actionItems,
    onAction,
    getStatusColor,
    getPolicyStatusLabel,
}) => {
    const policy = getPolicy(record);
    const status = policy?.status;
    const normalizedStatus = String(status ?? "").toLowerCase();
    const paid = isSalePaid(record);
    const provider = getProviderKey(record);

    const statusTag = (
        <Tag color={getStatusColor(status)} className="!m-0 inline-flex w-fit rounded-full px-2.5 text-xs">
            {getPolicyStatusLabel(status, t)}
        </Tag>
    );

    return (
        <article className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
            <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                    <p className="font-mono text-sm font-medium text-[#5D5DF6]">{record.id}</p>
                    <p className="mt-1 truncate text-base font-semibold text-[#2F2F46]">
                        {record.customerName || "—"}
                    </p>
                    {record.email ? (
                        <p className="mt-0.5 truncate text-sm text-gray-500">{record.email}</p>
                    ) : null}
                    <p className="mt-0.5 truncate text-sm text-gray-500">{record.carName || "—"}</p>
                    <p className="mt-1 text-xs text-gray-500">
                        {PROVIDER_LABELS[provider] ?? "—"}
                        <span className="mx-1 text-gray-300">·</span>
                        {formatCurrency(record.invoice?.total)}
                    </p>
                </div>
                {actionItems.length > 0 ? (
                    <RowActionsMenu
                        items={actionItems}
                        onClick={({ key }) => onAction(record, key)}
                        label={t("table.actions")}
                        icon={<HiDotsHorizontal size={18} />}
                        className="!h-8 !w-8 shrink-0 !rounded-full text-gray-500"
                    />
                ) : null}
            </div>

            <div className="mt-3 flex items-center justify-between gap-3 border-t border-gray-100 pt-3">
                {policy?.lastError && normalizedStatus === "failed" ? (
                    <Tooltip title={policy.lastError}>
                        <span className="inline-flex w-fit">{statusTag}</span>
                    </Tooltip>
                ) : (
                    statusTag
                )}
                <Tag
                    color={paid ? "success" : "warning"}
                    className="!m-0 inline-flex w-fit rounded-full px-2.5 text-xs">
                    {paid ? t("table.paid") : t("table.unpaid")}
                </Tag>
            </div>
        </article>
    );
};

InsuranceSaleMobileCard.propTypes = {
    record: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    actionItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    onAction: PropTypes.func.isRequired,
    getStatusColor: PropTypes.func.isRequired,
    getPolicyStatusLabel: PropTypes.func.isRequired,
};

export default InsuranceSaleMobileCard;
